<script>
  import ImagePanel from "../components/ImagePanel.svelte";
  import AnchorText from "../components/AnchorText.svelte";
  import LightBox from "../components/LightBox.svelte";

  let folder = "/images/tisak/veliki";
  let prefix = "mgc-";
  let start = 601;
  let finish = 612;
  let panelItems = [];

  for (let index = start; index <= finish; index++) {
    let index_str = "" + index;
    index_str = index_str.padStart(3, "0");
    panelItems.push({ id: index - start, url: folder + "/" + prefix + index_str + ".jpg", caption: start, copy: "" });
  }

  let currentImage = null;
  let caption = "Tisak velikog formata";
  let copy = `Što veća reklama to bolje.  Nudimo tisak velikog formata na raznim materijalima kao što su: platno (canvas), svjetlopropusne papire i naljepnice za svjetleće reklame, mesh, reflektirajuće naljepnice, fotopapir, itd.`;

  export let currentRoute;
  export let params;
</script>

<AnchorText {caption} {copy} />
<ImagePanel {panelItems} imageHeight="400px" bind:currentImage />
{#if currentImage != null}
  <LightBox lightboxItems={panelItems} bind:currentImage />
{/if}
